module.exports = __webpack_public_path__ + "img/img43.6b06581a.jpg";